import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { exchangeCodeForTokens } from '@/lib/auth-config';

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const savedState = sessionStorage.getItem('auth_state');

    sessionStorage.removeItem('auth_state');

    if (!code) {
      setError('No authorization code received');
      return;
    }

    if (!state || !savedState || state !== savedState) {
      setError('State validation failed. Please try logging in again.');
      return;
    }

    exchangeCodeForTokens(code)
      .then((tokens) => {
        sessionStorage.setItem('access_token', tokens.accessToken);
        sessionStorage.setItem('refresh_token', tokens.refreshToken);
        if (tokens.idToken) sessionStorage.setItem('id_token', tokens.idToken);
        navigate('/', { replace: true });
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : 'Authentication failed');
      });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="rounded-md bg-red-50 px-6 py-4 text-sm text-red-700">
          <p className="font-medium">Authentication failed</p>
          <p className="mt-1">{error}</p>
          <a href="/login" className="mt-3 inline-block text-red-900 underline">
            Try again
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <p className="text-sm text-slate-400">Signing in...</p>
    </div>
  );
}
